import {
    FormattedIdentityProviderConfiguration,
    IdentityProviderConfiguration,
    IdentityProviderCategory,
    IdentityProviderClassification,
    IdentityProviderCompany,
    IdentityProviderLoa,
    IdentityProviderProtocol
} from "@idw-types/data/identity-providers";

export const formatIdentityProviderConfigurations = (
    identityProviderConfigurations: Array<IdentityProviderConfiguration>,
    categories: Array<IdentityProviderCategory>,
    classifications: Array<IdentityProviderClassification>,
    companies: Array<IdentityProviderCompany>,
    loas: Array<IdentityProviderLoa>,
    protocols: Array<IdentityProviderProtocol>
): Array<FormattedIdentityProviderConfiguration> => {
    return identityProviderConfigurations.map(identityProviderConfiguration => formatIdentityProviderConfiguration(
        identityProviderConfiguration,
        categories,
        classifications,
        companies,
        loas,
        protocols
    ));
};

export const formatIdentityProviderConfiguration = (
    identityProviderConfiguration: IdentityProviderConfiguration,
    categories: Array<IdentityProviderCategory>,
    classifications: Array<IdentityProviderClassification>,
    companies: Array<IdentityProviderCompany>,
    loas: Array<IdentityProviderLoa>,
    protocols: Array<IdentityProviderProtocol>
): FormattedIdentityProviderConfiguration => {
    const category = categories.find(cat => cat.key === identityProviderConfiguration.category);
    const classification = classifications.find(cla => cla.id === identityProviderConfiguration.classificationID);
    const company = companies.find(com => com.id === identityProviderConfiguration.companyID);
    const loa = loas.find(loa => loa.key === identityProviderConfiguration.loa);
    const protocol = protocols.find(pro => pro.key === identityProviderConfiguration.protocol);
    return {
        category: category,
        changeRequestID: identityProviderConfiguration.changeRequestID,
        changeRequestStatus: identityProviderConfiguration.changeRequestStatus,
        changeRequestType: identityProviderConfiguration.changeRequestType,
        classification: classification,
        code: identityProviderConfiguration.code,
        company: company,
        id: identityProviderConfiguration.id,
        loa: loa,
        name: identityProviderConfiguration.name,
        protocol: protocol,
        permissions: identityProviderConfiguration.permissions
    };
};